"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetChartTypeEnum = void 0;
var WidgetChartTypeEnum;
(function (WidgetChartTypeEnum) {
    WidgetChartTypeEnum["line"] = "line";
    WidgetChartTypeEnum["bar"] = "bar";
    WidgetChartTypeEnum["donut"] = "donut";
    WidgetChartTypeEnum["text"] = "text";
    WidgetChartTypeEnum["counter"] = "counter";
    WidgetChartTypeEnum["radar"] = "radar";
    WidgetChartTypeEnum["gauge"] = "gauge";
})(WidgetChartTypeEnum = exports.WidgetChartTypeEnum || (exports.WidgetChartTypeEnum = {}));
